import * as React from "react"
import { configOptions } from "./config"

export const IFCViewerV4Description = {
  name: 'IFCViewerV4',
  component: React.lazy(() => import('./ifc-viewer' )),
  label: 'IFC Viewer V4 (ThatOpen Components Fragments V2)',
  variables: configOptions
} as const
